<template>
  <Sidebar class="position-relative sider" v-model:visible="visibleRight" position="right" :closable="true">
    <!-- :style="{ width: CallSidebarWidth }" -->
    <template #header>
      <b-row>
        <b-col lg="6" md="6">
          <div class="sidebarheader">
            <img src="../../../../assets/Img/contactpluslogo.png" alt="" style="width: 1.5rem; height: 1.5rem" />
            <div class="sidebarheadername">
              <h2>Connect Plus</h2>
              <p style="font-size: 10px">TM</p>
            </div>
          </div>
        </b-col>
        <b-col lg="6" md="6" class="d-flex flex-row-reverse">
          <i class="pi pi-times" @click="$emit('close'), stopTimer()"></i>
        </b-col>
      </b-row>
    </template>
    <!-- {{ isFormdata }}kk -->
    <!-- {{ isFormdata }} -->

    <b-container fluid>
      <!-- <div class="dialoption" v-show="isForm.callpatientmobile == ''"> -->
      <div class="dialoption">
        <p class="mb-0">Call Patient's Mobile</p>
        <img src="../../../../assets/Img/callimg.png" style="width: 25px" />
        <div class="field mb-0">
          <CustomDropdown v-model="isForm.callpatientmobile" :items="callpatientmobileoption"
            :id="$t('crm.tasks.tabs.promcollecttion.repeat')" :rules="{ required: false }" :required-icon="false"
            :showClear="false" :filter="false" />
        </div>
      </div>

      <div v-show="isForm.callpatientmobile == 1">
        <div class="dialoption" @click="clickToCallData(1)">
          <div>
            <p class="mb-0">Personal Number</p>
            <p class="light-txt mb-0">{{ isFormdata.Phone }}</p>
          </div>
          <img src="../../../../assets/Img/callimg.png" style="width: 25px" />
        </div>
        <div class="dialoption" v-show="isFormdata.Phone1" @click="clickToCallData(2)">
          <div>
            <p class="mb-0">Office Number</p>
            <p class="light-txt mb-0">{{ isFormdata.Phone1 }}</p>
          </div>
          <img src="../../../../assets/Img/callimg.png" style="width: 25px" />
        </div>
      </div>

      <div class="text-center">
        <div v-if="patientcallbtn" class="d-flex phone_center">
          <!-- <div class="d-flex"> -->
          <div class="position-relative">
            <img src="../../../../assets/Img/EmptyPhone.png" alt="" style="width: 80%" />
            <div class="loading CallLoading" v-if="CallLoading">
              <span>C</span>
              <span>o</span>
              <span>n</span>
              <span>n</span>
              <span>e</span>
              <span>c</span>
              <span>t</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
            <img src="../../../../assets/Img/DeclineCall.png" @click="callcut()" class="call-decline-icons" alt="" />
            <!-- <img @click="clickToCallData(1)" src="../../../../assets/Img/AcceptCall.png" class="call-accept-icons" alt="" /> -->
            <div class="callpatientnumber">
              <h3>{{ isFormdata.FirstName }} {{ isFormdata.LastName }}</h3>
              <p class="small-light-txt">{{ PhoneNumber }}</p>
            </div>
          </div>
          <!-- <div class="position-relative" v-if="isFormdata.Phone1">
            <img src="../../../../assets/Img/EmptyPhone.png" alt="" style="width: 80%" />
            <div class="loading CallLoading" v-if="CallLoading1">
              <span>C</span>
              <span>o</span>
              <span>n</span>
              <span>n</span>
              <span>e</span>
              <span>c</span>
              <span>t</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
            <img src="../../../../assets/Img/DeclineCall.png" @click="callcut()" class="call-decline-icons" alt="" />
            <img @click="clickToCallData(2)" src="../../../../assets/Img/AcceptCall.png" class="call-accept-icons" alt="" />
            <div class="callpatientnumber">
              <h3>{{ isFormdata.FirstName }} {{ isFormdata.LastName }}</h3>
              <p class="light-txt">{{ isFormdata.Phone1 }}</p>
            </div>
          </div> -->
        </div>

        <div class="position-relative phone_center" v-if="patientcalloption">
          <img src="../../../../assets/Img/contactdetailsphone.png" alt="" style="width: 80%" />
          <div class="loading CallLoading" v-if="CallLoading">
            <span>C</span>
            <span>o</span>
            <span>n</span>
            <span>n</span>
            <span>e</span>
            <span>c</span>
            <span>t</span>
            <span>i</span>
            <span>n</span>
            <span>g</span>
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </div>
          <div class="callpatientname">
            <h3>{{ isFormdata.FirstName }} {{ isFormdata.LastName }}</h3>
            <p class="small-light-txt">{{ PhoneNumber }}</p>
            <p class="text-start light-txt">{{ formatTime() }}</p>
          </div>
          <img src="../../../../assets/Img/DeclineCall.png" @click="callcut()" class="call-decline" alt="" />
        </div>
      </div>
      <div v-if="patientcalloption">
        <b-row>
          <b-col>
            <!-- {{ dropDownList.assignOption }} -->
            <div class="field">
              <CustomDropdown v-model="isForm.agentName" :name="$t('crm.tasks.tabs.promcollecttion.repeat')"
                :items="dropDownList.assignOption" :id="$t('crm.tasks.tabs.promcollecttion.repeat')"
                :label="$t('crm.tasks.tabs.promcollecttion.repeat')" :rules="{ required: false }" :required-icon="true"
                @update:modelValue="AgentOnChange(isForm.agentName)" />
            </div>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col>
            <div class="field">
              <CustomDropdown
                v-model="GroupAgent.agentName"
                :name="$t('crm.tasks.tabs.promcollecttion.GroupCall')"
                :items="GroupAgentdropDownList.GroupassignOption"
                :id="$t('crm.tasks.tabs.promcollecttion.GroupCall')"
                :label="$t('crm.tasks.tabs.promcollecttion.GroupCall')"
                :rules="{ required: false }"
                :required-icon="true"
                @update:modelValue="GroupAgentOnChange"
              />
            </div>
          </b-col>
        </b-row> -->
        <!-- {{ callid
        }} -->
        <div v-if="AgentHideAndShow == true">
          <b-row>
            <b-col lg="6" md="6">
              <div class="calloptions MouseHover" @click="clickToCallOptions('1')">
                <img src="../../../../assets/Img/callimg.png" alt="" style="width: 1.25rem" class="livecallicon" />
                <h3>Monitor call</h3>
              </div>
            </b-col>
            <b-col lg="6" md="6">
              <div class="calloptions MouseHover" @click="clickToCallOptions('2')">
                <img src="../../../../assets/Img/callimg.png" alt="" style="width: 1.25rem" class="livecallicon" />
                <h3>Whisper call</h3>
              </div>
            </b-col>
          </b-row>
          <b-row class="py-3">
            <b-col lg="6" md="6">
              <div class="calloptions MouseHover" @click="clickToCallOptions('3')">
                <img src="../../../../assets/Img/callimg.png" alt="" style="width: 1.25rem" class="livecallicon" />
                <h3>Barge</h3>
              </div>
            </b-col>
            <b-col lg="6" md="6">
              <div class="calloptions MouseHover" @click="clickToCallOptions('4')">
                <img src="../../../../assets/Img/callimg.png" alt="" style="width: 1.25rem" class="livecallicon" />
                <h3>Transfer call by Mobile</h3>
              </div>
            </b-col>
            <b-col lg="6" md="6">
              <div class="calloptions MouseHover" @click="clickToCallOptions('5')">
                <img src="../../../../assets/Img/callimg.png" alt="" style="width: 1.25rem" class="livecallicon" />
                <h3>Transfer call by Intercom</h3>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="GroupAgentHideAndShow == true">
          <b-row>
            <b-col lg="6" md="6">
              <div class="calloptions MouseHover" @click="clickToCallOptions('6')">
                <img src="../../../../assets/Img/callimg.png" alt="" style="width: 1.25rem" class="livecallicon" />
                <h3>Transfer Group call</h3>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </Sidebar>
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  watchEffect,
  reactive,
  watch,
  onBeforeUnmount,
} from "vue";

import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";
import TextArea from "../../../../components/FormComponents/TextArea.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import TeleCallService from "../../service/teleCallService";
import AgentService from "../../service/agentService";
import { useToast } from "primevue/usetoast";
import LiveCallService from "../../service/liveCallsService";
import SignalRService from "../../utils/signalR";

export default defineComponent({
  components: {
    Headerlayout,
    BacktoPage,
    TextArea,
    Footer,
    CustomDropdown,
    TextField,
    Datepicker,
    useToast,
  },
  props: {
    visibleRight: {
      type: Boolean,
      default: ref(false),
    },
    status: {
      type: Boolean,
    },
    smspreview: {
      type: Boolean,
      default: false,
    },
    notificationpreview: {
      type: Boolean,
      default: false,
    },
    whatsapppreview: {
      type: Boolean,
      default: false,
    },
    ivrpreview: {
      type: Boolean,
      default: false,
    },
    isFormdata: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    //Declarations
    const patientcalloption = ref(false);
    const signalRService = new SignalRService();
    const CallLoading = ref(false);
    const CallLoading1 = ref(false);
    const patientcallbtn = ref(false);
    const connectpluslogo = ref(false);
    const loading = ref(false);
    const toast = useToast();
    const contactTableList = ref([] as any[]);
    const PhoneNumber = ref();
    const callid = ref();
    let AgentId = ref();
    let localstoragedata = ref();
    let OrganizationId = ref();
    let BranchId = ref();
    // let CallSidebarWidth = ref("");

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const callpatientmobileoption = ref([
      { name: "Dial In", value: 1 },
      { name: "VOIP", value: 2 },
    ]);
    // watch(
    //   () => props.isFormdata.Phone1,
    //   (newVal) => {
    //     if (newVal === "") {
    //       CallSidebarWidth.value = "24%";
    //     } else if (!newVal) {
    //       CallSidebarWidth.value = "24%";
    //     } else {
    //       CallSidebarWidth.value = "40%";
    //     }
    //   }
    // );

    onMounted(() => {
      // alert(JSON.stringify(props.isFormdata.Phone))

      localstoragedata.value = localStorage.getItem("UsersData");
      localstoragedata.value = JSON.parse(localstoragedata.value);
      OrganizationId.value = localstoragedata.value.OrganizationId;
      BranchId.value = localstoragedata.value.BranchId;
      AgentId.value = localstoragedata.value.AgentId;

      liveCallList();
      startConnection();
      // let intervalId = setInterval(liveCallList, 5000);
      agentList();
      // GroupAgentList;

      props.status == true ? callpatient() : "";
    });

    //Functions
    function callpatient() {
      patientcallbtn.value = false;
      patientcalloption.value = true;
      connectpluslogo.value = true;
      startTimer();
    }

    const startConnection = async () => {


      await signalRService.startConnection();

      signalRService.SendLiveCallsNotification((message: any[]) => {
        // alert('s')
        // debugger;
        // debugger;
        contactTableList.value = [];
        contactTableList.value.push(...message);
        contactTableList.value.filter(
          (item) =>
            item.customer_number == props.isFormdata.Phone &&
            item.CallStatus == 0
        );
        loading.value = false;
        callid.value = contactTableList.value[0]["call_id"];
        // alert(callid.value)
      });
    };

    const clickToCallData = async (data) => {
      patientcallbtn.value = true;
      let isCallform = ref({
        agentID: props.isFormdata.AssignTo,
        agent_number: props.isFormdata.TTAgentId,
        async: 0,
        destination_number: 0,
        call_timeout: 0,
        custom_identifier: 0,
      });
      if (data === 1) {
        isCallform.value.destination_number = props.isFormdata.Phone;
        PhoneNumber.value = props.isFormdata.Phone;
        CallLoading.value = true;
      } else {
        isCallform.value.destination_number = props.isFormdata.Phone1;
        PhoneNumber.value = props.isFormdata.Phone1;
        CallLoading1.value = true;
      }
      // // loading.value = true;
      try {
        const response = await TeleCallService.clicktocall(isCallform.value);
        // CallSidebarWidth.value = " 24%";
        let data = response["result"];
        if (response["result"] == "") {
          callpatient();
          agentList();
        }
        CallLoading.value = false;
        CallLoading1.value = false;
        // loading.value = false;
      } catch (error) {
        // loading.value = false;
        alert(error);
      }
    };
    const timerRunning = ref(false);
    const seconds = ref(0);
    let timerId = ref();

    const startTimer = () => {
      timerRunning.value = true;
      timerId.value = setInterval(() => {
        seconds.value++;
      }, 1000);
    };

    const stopTimer = () => {
      timerRunning.value = false;
      clearInterval(timerId.value);
      seconds.value = 0;
    };

    const formatTime = () => {
      const minutes = Math.floor(seconds.value / 60);
      const remainingSeconds = seconds.value % 60;

      return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
        .toString()
        .padStart(2, "0")}`;
    };

    // Cleanup on component unmount to avoid memory leaks
    onBeforeUnmount(() => {
      clearInterval(timerId.value);
    });

    const clickToCallOptions = async (Type: String) => {
      CallLoading.value = true;

      let InterComOrMobileNumber = "";

      if (Type == "4") {
        InterComOrMobileNumber =
          ObjInterComOrMobileNumber.value.InterComNumber.toString();
      } else if (Type == "5") {
        InterComOrMobileNumber =
          ObjInterComOrMobileNumber.value.InterComNumber.toString();
      } else {
        InterComOrMobileNumber = "0";
      }

      let isCallform = ref({
        agentID: 0,
        clientNumber: 0,
        type: Type,
        call_id: callid.value,
        agent_id: String(isForm.value.agentName),
        intercom: InterComOrMobileNumber,
      });

      try {
        if (isForm.value.agentName != null) {
          const response = await TeleCallService.clicktoCallOptions(
            isCallform.value
          );
          let data = response["result"];
        } else {
          toast.add({
            severity: "warn",
            summary: "Please select the agent",
            detail: "Agent",
            life: 3000,
          });
        }
        CallLoading.value = false;
      } catch (error) {
        alert(error);
      }
    };

    async function liveCallList() {
      loading.value = true;
      try {
        const result = await LiveCallService.getList();
        result["result"] = result["result"].map((item) => {
          item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
          return item;
        });
        contactTableList.value = result["result"].filter(
          (item) =>
            item.customer_number == "+91" + props.isFormdata.Phone &&
            item.CallStatus == 0
        );
        loading.value = false;
        callid.value = contactTableList.value[0]["call_id"];
      } catch (error) {
        loading.value = false;
      }
    }
    const isForm = ref({
      callpatientmobile: ref(),
      agentName: ref(),
    });

    const GroupAgent = ref({
      agentName: ref(),
    });

    const dropDownList = ref({
      assignByOption: [],
      assignOption: [],
    });

    const GroupAgentdropDownList = ref({
      GroupassignByOption: [],
      GroupassignOption: [],
    });

    async function agentList() {
      debugger;
      try {
        const result = await AgentService.AgentListWithBranch(
          usersData.OrganizationId
        );
        console.log(result);
        result["result"] = result["result"]
          .filter(
            (i1) =>
              i1.ClientId == OrganizationId.value &&
              // i1.Id != props.isFormdata.AssignTo
              i1.Id != usersData.AgentId
          )
          .map((item) => {
            item.name = item.Name;
            item.value = Number(item.TTAgentId);
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });

        dropDownList.value.assignOption = result["result"];
      } catch (error) {
        alert(error);
      }
    }

    // async function GroupAgentList() {
    //   debugger;
    //   loading.value = true;
    //   // alert(AgentId.value)
    //   try {
    //     const result = await AgentService.GroupAgentListWithBranch(
    //       OrganizationId.value,
    //       usersData.AgentId
    //     );
    //     console.log(result);
    //     result["result"] = result["result"].map((item) => {
    //       item.name = item.Name;
    //       item.value = item.TTAgentId;
    //       item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
    //       return item;
    //     });

    //     GroupAgentdropDownList.value.GroupassignOption = result["result"];
    //     loading.value = false;
    //   } catch (error) {
    //     loading.value = false;
    //   }
    // }

    let ObjInterComOrMobileNumber = ref({
      InterComNumber: "",
      MobileNumber: "",
    });

    let AgentHideAndShow = ref(false);
    let GroupAgentHideAndShow = ref(false);

    function AgentOnChange(value) {
      if (value != 0 && value != null) {
        const agent = dropDownList.value.assignOption.find(
          (item) => item["value"] === value
        );

        if (agent) {
          ObjInterComOrMobileNumber.value.InterComNumber = agent["Intercom"];
          ObjInterComOrMobileNumber.value.MobileNumber =
            agent["FollowmeNumber"];
        }

        AgentHideAndShow.value = true;
        GroupAgentHideAndShow.value = false;
      }

      // GroupAgentdropDownList.value.GroupassignOption = [];
      GroupAgent.value.agentName = ref();
    }

    function GroupAgentOnChange(value) {
      debugger;
      if (value != 0 && value != null) {
        AgentHideAndShow.value = false;
        GroupAgentHideAndShow.value = true;
        // dropDownList.value.assignOption = [];
        isForm.value.agentName = ref();
      }
    }

    watch(
      () => props.isFormdata.call_id,
      (newVal) => {
        callid.value = props.isFormdata.call_id;
      }
    );
    watch(
      () => props.isFormdata,
      (newVal) => {
        PhoneNumber.value = props.isFormdata.Phone;
      }
    );
    function callcut() {
      patientcallbtn.value = false;
      patientcalloption.value = false;
      CallLoading.value = false;
      CallLoading1.value = false;
      emit("close");
    }
    return {
      // CallSidebarWidth,
      CallLoading,
      CallLoading1,
      PhoneNumber,
      callcut,
      stopTimer,
      formatTime,
      contactTableList,
      clickToCallOptions,
      dropDownList,
      isForm,
      clickToCallData,
      patientcalloption,
      patientcallbtn,
      callpatient,
      connectpluslogo,
      callid,
      AgentOnChange,
      GroupAgentOnChange,
      AgentHideAndShow,
      GroupAgentHideAndShow,
      GroupAgentdropDownList,
      GroupAgent,
      callpatientmobileoption,
    };
  },
});
</script>

<style lang="scss">
.livecallicon {
  margin-right: 10px;
}

.patientcallbtn {
  padding-bottom: 25px;
  border-bottom: 1px solid #e1e1e1;
}

.patientcallbtn .p-button {
  background-color: white;
  color: black;
  border: 1px solid #0a82ff;
  padding: 0.3rem 1.75rem;
}

.patientcallbtn .p-button:enabled:hover {
  background-color: white;
  color: black;
  border: 1px solid #0a82ff;
  padding: 0.3rem 1.75rem;
}

.calloptions {
  display: flex;
  align-items: center;
  justify-content: left;
  border: 1px solid #e1e1e1;
  padding: 8px;
  border-radius: 10px;
  cursor: pointer;
}

.calloptions h3 {
  font-size: 11px;
}

.callpatientnumber {
  width: 200px;
  position: absolute;
  top: 13%;
  left: 11%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.callpatientnumber h3 {
  color: white;
}

.callpatientnumber p {
  color: #999999;
  padding: 0 5px;
}

.callpatientname {
  width: 200px;
  position: absolute;
  top: 11%;
  left: 11%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.callpatientname h3 {
  color: white;
  padding: 0 5px;
}

.callpatientname p {
  color: #999999;
  padding: 0 5px;
}

.fromcall {
  height: 60px;
  width: 60px;
  border: 1px solid #e1e1e1;
  border-radius: 50px;
}

.sidebarheader {
  display: flex;
  align-items: center;
}

.sidebarheader .sidebarheadername {
  margin-left: 5px;
  display: flex;
  white-space: nowrap;
}

.callconnectborder {
  width: 115px;
  position: absolute;
  border-top: 2px dotted #e1e1e1;
  top: 50%;
  left: 29%;
  z-index: -1;
  padding-top: 10px;
}

.callconnectborder p {
  font-size: 10px;
  color: #999999;
}

.call-accept-icons {
  width: 50px;
  position: absolute;
  bottom: 8%;
  left: 20%;
}

.call-decline-icons {
  width: 45px;
  position: absolute;
  bottom: 8%;
  right: 43%;
}

.call-decline {
  width: 47px;
  position: absolute;
  bottom: 10%;
  right: 42%;
}

.loading {
  font-size: 18px;
  font-weight: 800;
  text-align: center;

  span {
    display: inline-block;
    margin-left: 3px !important;
  }
}

.CallLoading {
  position: absolute;
  top: 25%;
  left: 27%;

  span {
    margin: 0 -0.075em;
    animation: CallLoading 0.7s infinite alternate;
    color: #ffffff;
    font-weight: normal;

    @for $i from 1 through 6 {
      &:nth-child(#{$i + 1}) {
        animation-delay: #{$i * 0.1}s;
      }
    }
  }
}

@keyframes CallLoading {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.8);
  }
}

.dialoption {
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  padding: 5px;
  margin: 5px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;

  p {
    font-size: 14px;
  }
}

.dialoption .field label {
  display: none;
}

.dialoption .field .p-dropdown .p-inputtext {
  font-size: 14px;
}

.phone_center {
  width: max-content;
  margin: 0 auto;
}

.sider {
  width: 24%;
}

@media (max-width: 425px) {
  .sider {
    width: 100%;
  }
}
</style>
